import script from "./Sports.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sports.vue?vue&type=script&setup=true&lang=ts"

import "./Sports.vue?vue&type=style&index=0&id=430c6ed9&lang=css"

const __exports__ = script;

export default __exports__